// Show/hide cart

document
  .querySelector("#cart-icon-bubble")
  .addEventListener("click", function () {
    const cartDrawer = document.querySelector(".cart__drawer");
    cartDrawer.classList.toggle("-show");
  });

function initAddToCartButtons(container = document) {
  const buttons = container.querySelectorAll(".add-to-cart");

  buttons.forEach((button) => {
    button.addEventListener("click", async function () {
      const variant = parseInt(this.dataset.variant);
      const variants = JSON.parse(this.dataset.variants);
      const qty = parseInt(this.dataset.qty) || 1;
      const unit = this.dataset.unit || "unit";
      const sizes = this.dataset.sizes.split(", ").map(Number);

      this.classList.add("-loading");

      let id = variant || variants[0];

      // Lógica para actualizar cantidad y variante
      let { productExists, updatedQty, updatedVariant } = await checkForProduct(
        qty,
        variants,
        sizes,
      );
      id = updatedVariant;

      const formData = {
        items: [
          {
            id: id,
            quantity: updatedQty,
            properties: {
              Unidad: unit,
              Variant1: variants[0],
              Variant2: variants[1],
              Variant3: variants[2],
            },
          },
        ],
      };

      await addItem(formData);
      await getCart();

      this.classList.remove("-loading");
    });
  });
}

initAddToCartButtons();

// Show hide cart for related products
setTimeout(() => {
  const relatedContainer = document.querySelector(".related-products");
  if (relatedContainer) {
    initAddToCartButtons(relatedContainer); // solo afecta ese contenedor
  }
}, 3500);

// Add item to cart
async function addItem(formData) {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      showNotification("Producto sin stock.", "error");
      throw new Error("Failed to add item");
    }

    document.querySelector(".cart__drawer").classList.add("-show");
    document.documentElement.classList.add("-openedCart");
  } catch (error) {
    console.error("Error:", error);
  } finally {
    document.querySelectorAll(".add-to-cart").forEach((btn) => {
      btn.classList.remove("-loading");
    });
  }
}

// Delete item from cart
async function deleteItem(key) {
  try {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: { [key]: 0 } }),
    });

    showNotification("El producto fue eliminado del pedido.", "error");
    await getCart();
  } catch (error) {
    console.error("Error:", error);
  }
}

const compraMinima = 2000000;
// Fetch and update cart UI
async function getCart() {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    const buyButton = document.querySelector(".cart__actions .button");

    // Update cart totals
    document.querySelector("#ajax-cart-total").textContent =
      `Total: ${formatMoney(cart.total_price)}`;

    // Update cart minimum
    if (cart.total_price < compraMinima) {
      document.querySelector("#ajax-cart-minimum").textContent =
        `Te faltan ${formatMoney(compraMinima - cart.total_price)} para completar la compra`;
      buyButton.disabled = true;
    } else {
      buyButton.disabled = false;
      document.querySelector("#ajax-cart-minimum").textContent = "";
    }

    // Update installments
    const installments = cart.total_price / 3;
    document.querySelector("#ajax-cart-cuotas").textContent =
      `3 cuotas sin interés de ${formatMoney(installments)}`;

    // Update cart items
    const itemsContainer = document.querySelector("#ajax-cart-items");
    itemsContainer.innerHTML =
      cart.items.length === 0
        ? '<div class="no-products">No hay productos en el carrito</div>'
        : "";

    // Re enable buttons if there are items in the cart
    if (cart.items.length > 0) {
      // Disable all buttons until the request is done
      const addButtons = document.querySelectorAll(".cart-plus");
      addButtons.forEach((button) => {
        button.disabled = false;
      });
      const minusButtons = document.querySelectorAll(".cart-minus");
      minusButtons.forEach((button) => {
        button.disabled = false;
      });
    }

    // Deactivate loader (only if is active)
    const loader = document.querySelector(".cart__loader");
    if (loader.classList.contains("cart__loader--active")) {
      loader.classList.remove("cart__loader--active");
    }

    cart.items.forEach((item) => {
      const unit = item.properties?.Unidad || "kg";
      let price = item.price;

      if (item.discounts?.length) {
        price = item.price - item.discounts[0].amount / item.quantity;
      }

      itemsContainer.insertAdjacentHTML(
        "beforeend",
        `
        <div class="cart__item" data-key="${item.key}">
          <div class="cart__item-image">
            <img src="${item.featured_image.url}" alt="${item.featured_image.alt}">
          </div>
          <div class="cart__item-content">
            <p class="name">${item.product_title} ${item.variant_options?.[0] || ""}</p>
            <div class="price">a ${formatMoney(price)} c/u.</div>

            <div class="cart-quantity__selector"
              data-key="${item.key}"
              data-product="${item.product_id}"
              data-variant="${item.id}"
              data-variants='${JSON.stringify([item.properties?.Variant1, item.properties?.Variant2, item.properties?.Variant3])}'
              data-unit="${item.properties?.Unidad || "u."}"
              data-sizes="${item.properties?.Sizes || "1, 10, 30"}">
              <button class="cart-minus" data-qty="minus" aria-label="Disminuir cantidad">-</button>
              <input class="cart-quantity__input" data-qty="input" type="text" placeholder="${item.quantity}" min="1" aria-label="Cantidad">
              <button class="cart-plus" data-qty="plus" aria-label="Aumentar cantidad">+</button>
            </div>

          </div>
          <div class="cart__item-trash" data-key="${
            item.key
          }"> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" height="24px" width="24px"><g data-name="70-Trash"><path d="m29.89 6.55-1-2A1 1 0 0 0 28 4h-7V2a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2v2H4a1 1 0 0 0-.89.55l-1 2A1 1 0 0 0 3 8h2v22a2 2 0 0 0 .47 1.41A2 2 0 0 0 7 32h18a2 2 0 0 0 2-2V8h2a1 1 0 0 0 .89-1.45zM13 2h6v2h-6zm12 28H7V8h18z"/><path d="M17 26V10a2 2 0 0 0-2 2l.06 14H15v2a2 2 0 0 0 2-2zM22 26V10a2 2 0 0 0-2 2l.06 14H20v2a2 2 0 0 0 2-2zM12 26V10a2 2 0 0 0-2 2l.06 14H10v2a2 2 0 0 0 2-2z"/></g></svg> </div>
        </div>
      `,
      );

      if (cart.items.length > 0) {
        const addButtons = document.querySelectorAll(".cart-plus");
        addButtons.forEach((button) => {
          button.addEventListener("click", updateItemWithinCart);
        });
        const minusButtons = document.querySelectorAll(".cart-minus");
        minusButtons.forEach((button) => {
          button.addEventListener("click", updateItemWithinCart);
        });
        const inputButtons = document.querySelectorAll(".cart-quantity__input");
        inputButtons.forEach((button) => {
          button.addEventListener("change", updateItem);
        });
      }

      document.querySelectorAll(".cart-quantity__input").forEach((input) => {
        input.addEventListener("focus", () => {
          document
            .querySelector(".cart__summary")
            ?.classList.add("hide-on-input-focus");
        });

        input.addEventListener("blur", () => {
          document
            .querySelector(".cart__summary")
            ?.classList.remove("hide-on-input-focus");
        });
      });
    });

    // Update cart count
    const countBubble = document.querySelector(".cart-count-bubble > span");
    if (countBubble) {
      countBubble.textContent = cart.item_count || cart.items.length;
    }

    // Reinitialize UI
    // reinitScrollbar();
    // setupDeleteHandlers();
    initDeleteHandlers();
  } catch (error) {
    console.error("Error fetching cart:", error);
  }
}

const updateItem = async (e) => {
  const button = e.target;
  const container = button.closest(".cart-quantity__selector");
  const key = container.dataset.key;
  const variant = container.dataset.variant;
  const unit = container.dataset.unit;
  const variants = JSON.parse(container.dataset.variants);
  const sizes = container.dataset.sizes.split(", ").map(Number);

  qty = parseInt(button.value);

  // Disable all buttons until the request is done
  const addButtons = document.querySelectorAll(".cart-plus");
  addButtons.forEach((button) => {
    button.disabled = true;
  });
  const minusButtons = document.querySelectorAll(".cart-minus");
  minusButtons.forEach((button) => {
    button.disabled = true;
  });

  // Activate loader
  const loader = document.querySelector(".cart__loader");
  loader.classList.add("cart__loader--active");

  // Lógica para actualizar cantidad y variante
  let updatedVariant = variants[0];
  if (qty >= sizes[1] && qty < sizes[2]) updatedVariant = variants[1];
  if (qty >= sizes[2]) updatedVariant = variants[2];
  let mustDelete = false;
  if (key != updatedVariant) {
    mustDelete = true;
  }

  try {
    if (mustDelete) {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: { [key]: 0 } }),
      });

      const formData = {
        items: [
          {
            id: updatedVariant,
            quantity: qty,
            properties: {
              Unidad: unit,
              Variant1: variants[0],
              Variant2: variants[1],
              Variant3: variants[2],
            },
          },
        ],
      };

      await addItem(formData);
    } else {
      await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates: { [updatedVariant]: qty } }),
      });
    }

    await getCart();
  } catch (error) {
    console.error("Error:", error);
  }
};

const updateItemWithinCart = async (e) => {
  const button = e.target;
  if (button.disabled) return;
  let qty = 0;
  if (button.dataset.qty == "minus") {
    qty = -1;
  } else if (button.dataset.qty == "plus") {
    qty = 1;
  }
  const container = button.closest(".cart-quantity__selector");
  const input = container.querySelector(".cart-quantity__input");
  const key = container.dataset.key;
  const product = container.dataset.product;
  const variant = container.dataset.variant;
  const variants = JSON.parse(container.dataset.variants);
  const unit = container.dataset.unit;
  const sizes = container.dataset.sizes.split(", ").map(Number);

  let id = variant || variants[0];

  // Disable all buttons until the request is done
  const addButtons = document.querySelectorAll(".cart-plus");
  addButtons.forEach((button) => {
    button.disabled = true;
  });
  const minusButtons = document.querySelectorAll(".cart-minus");
  minusButtons.forEach((button) => {
    button.disabled = true;
  });

  // Activate loader
  const loader = document.querySelector(".cart__loader");
  loader.classList.add("cart__loader--active");

  // Lógica para actualizar cantidad y variante
  let { productExists, updatedQty, updatedVariant } = await checkForProduct(
    qty,
    variants,
    sizes,
  );
  id = updatedVariant;

  const formData = {
    items: [
      {
        id: id,
        quantity: updatedQty,
        properties: {
          Unidad: unit,
          Variant1: variants[0],
          Variant2: variants[1],
          Variant3: variants[2],
        },
      },
    ],
  };

  await addItem(formData);
  await getCart();
};

// Money formatting (replaces Shopify.formatMoney)
function formatMoney(cents, format = "${{amount}}") {
  if (typeof cents === "string") cents = parseInt(cents);
  const value = (cents / 100).toFixed(2);
  return format.replace("{{amount}}", value);
}

// Notification system (replaces Noty)
function showNotification(message, type = "success") {
  const notification = document.createElement("div");
  notification.className = `notification ${type}`;
  notification.textContent = message;
  document.body.appendChild(notification);

  setTimeout(() => {
    notification.remove();
  }, 2000);
}

async function updateQty(qty, id) {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart");

    const cart = await response.json();
    let newQty = qty;

    cart.items.forEach((item) => {
      if (item.properties?.Variant1 == id) {
        newQty = qty + item.quantity;
      }
    });

    return newQty;
  } catch (error) {
    console.error("Error updating quantity:", error);
    return qty; // Return original quantity as fallback
  }
}

const initCartDrawerHandler = () => {
  // Cache DOM elements
  const cartTrigger = document.querySelector(".header-icon-cart-trigger");
  const cartDrawer = document.querySelector(".cart__drawer");
  const cartClose = document.querySelector(".cart-close-cross");
  const cartOverlay = document.querySelector(".cart__overlay");
  const cartContent = document.querySelector(".cart__content");
  const htmlElement = document.documentElement;

  // Show cart drawer
  if (cartTrigger) {
    cartTrigger.addEventListener("click", function () {
      cartDrawer.classList.add("-show");
      htmlElement.classList.add("-openedCart");
    });
  }

  // Hide cart drawer (used by multiple elements)
  function hideCart() {
    cartDrawer.classList.remove("-show");
    htmlElement.classList.remove("-openedCart");
  }

  // Close buttons
  if (cartClose) cartClose.addEventListener("click", hideCart);

  // Overlay behavior - closes drawer but doesn't propagate
  if (cartOverlay) {
    cartOverlay.addEventListener("click", function (e) {
      hideCart();
      e.stopPropagation();
    });
  }

  // Stop propagation for these elements
  if (cartContent) {
    cartContent.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  }

  if (cartDrawer) {
    cartDrawer.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  }
};

function initDeleteHandlers() {
  document.querySelectorAll(".cart__item-trash").forEach((button) => {
    button.addEventListener("click", () => {
      deleteItem(button.dataset.key);
    });
  });
}

async function checkForProduct(qty, variants, sizes) {
  try {
    const response = await fetch("/cart.js");
    if (!response.ok) throw new Error("Failed to fetch cart");

    const cart = await response.json();

    let productExists = false;
    let updatedVariant = variants[0];

    // Check all items in parallel for better performance
    await Promise.all(
      cart.items.map(async (item) => {
        if (item.properties?.Variant1 == variants[0]) {
          productExists = true;

          // Remove existing item
          await fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              updates: { [item.key]: 0 },
            }),
          })
            .then((response) => response.json())
            // .then(console.log('Successfully removed item from cart'))
            .catch(console.error);

          qty += item.quantity;
        }
      }),
    );

    if (qty >= sizes[1] && qty < sizes[2]) updatedVariant = variants[1];
    if (qty >= sizes[2]) updatedVariant = variants[2];

    return {
      productExists: productExists,
      updatedQty: qty,
      updatedVariant: updatedVariant,
    };
  } catch (error) {
    console.error("Error checking product:", error);
    return false;
  }
}

document.addEventListener("DOMContentLoaded", () => {
  initDeleteHandlers();
  initCartDrawerHandler();

  document
    .querySelector(".cart__drawer .button")
    .addEventListener("click", function (e) {
      e.preventDefault();
      window.location.href = "/checkout";
    });

  // Show/hide cart desde el ícono del header asegurando data fresca
  (() => {
    const bubble = document.querySelector("#cart-icon-bubble");
    const cartDrawer = document.querySelector(".cart__drawer");
    const htmlEl = document.documentElement;

    if (!bubble || !cartDrawer) return;

    // Click: prevenimos Dawn y usamos nuestro flujo
    bubble.addEventListener("click", async (e) => {
      e.preventDefault();
      // Evita que el listener de Dawn (cart-drawer.js) también se ejecute
      e.stopImmediatePropagation();

      // Trae el estado actual del carrito y pinta el UI
      await getCart();

      // Abre el drawer custom
      cartDrawer.classList.add("-show");
      htmlEl.classList.add("-openedCart");
    });

    // Accesibilidad: abrir con SPACE/ENTER
    bubble.addEventListener("keydown", async (e) => {
      const code = e.code || e.key;
      if (code === "Space" || code === "Enter") {
        e.preventDefault();
        e.stopImmediatePropagation();
        await getCart();
        cartDrawer.classList.add("-show");
        htmlEl.classList.add("-openedCart");
      }
    });
  })();
});
